import {ButtonGroup} from "@mui/material";
import React, {FC, useEffect} from "react";
import {useTranslation} from "react-i18next";
import styled from "styled-components/macro";
import {useSelector} from "../../../../redux/store";
import {getCompanies, getUserProfile} from "../../../../selectors";
import {IUser} from "../../../../models/User";
import {Grid, Theme, useMediaQuery} from "@material-ui/core";
import SelectCompany from "./SelectCompany";
import Box from "@mui/material/Box";

type CustomButtonProps = {
  active?: boolean
}

const CustomButton = styled.button<CustomButtonProps>`
  font-weight: 500;
  letter-spacing: 0.396938px;
  color: ${(props) => props.active ? '#000000' : '#D9D9D9'};
  background: ${(props) => props.active ? 'linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%)' : '#2E3B4E'};
  box-shadow: 0 0 18.5238px rgba(53, 64, 82, 0.05);
  padding: 7px 24px;
  transition: opacity 0.2s;
  &:hover {
    opacity: ${(props) => props.active ? '1' : '0.86'};
  }
`

type PropsType = {
  filterBy: any;
  selectedCompanyId: string
  handleChangeFilter: (filter: string) => void
  onSetSelectCompanyId: (companyId: string) => void
}

const PropertyFilters: FC<PropsType> = ({
  filterBy,
  handleChangeFilter,
  selectedCompanyId,
  onSetSelectCompanyId
}) => {
  const { t } = useTranslation();
  const companies = useSelector<any>(getCompanies)
  const userProfile = useSelector<IUser | undefined>(getUserProfile);
  const sm = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <Box
      display={'flex'}
      height={'100%'}
      ml={sm ? 0 : 3}
      mt={sm ? 3 : 0}
      flexDirection={sm ? 'column' : 'row'}
    >
      <ButtonGroup
        variant="outlined"
        size="large"
        fullWidth={sm}
        style={{height: sm ? '43px' : 'unset'}}
      >
        <CustomButton
          style={{
            borderRadius: '5px 0 0 5px',
            borderRight: '1px solid #25303fc7',
            width: sm ? '100%' : 'unset',
        }}
          active={filterBy === 'show_all'}
          onClick={() => handleChangeFilter('show_all')}
        >
          {t('propertyListPage_showAll')}
        </CustomButton>
        <CustomButton
          style={{width: sm ? '100%' : 'unset',}}
          active={filterBy === 'completed'}
          onClick={() => handleChangeFilter('completed')}
        >
          {t('propertyListPage_completed')}
        </CustomButton>
        <CustomButton
          style={{borderRadius: '0 5px 5px 0', borderLeft: '1px solid #25303fc7', width: sm ? '100%' : 'unset',}}
          active={filterBy === 'incomplete'}
          onClick={() => handleChangeFilter('incomplete')}
        >
          {t('propertyListPage_incomplete')}
        </CustomButton>
      </ButtonGroup>
      {userProfile?.is_staff ? (
        <Box
          ml={sm ? 0 : 3}
          mt={sm ? 3 : 0}
          display={'flex'}
          height={sm ? '43px' : 'unset'}
          maxWidth={sm ? 'unset' : '300px'}
          width={'100%'}
        >
          <SelectCompany
            selected={selectedCompanyId}
            setSelected={onSetSelectCompanyId}
            list={companies ? companies : []}
          />
        </Box>
      ) : null}
    </Box>
  )
}

export default PropertyFilters